import React from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  Fade,
  Modal,
  Typography,
} from "@mui/material";

export default function ModalLoadingMessage({ header, message, open }) {
  return (
    <Modal
      disableAutoFocus
      open={open}
      closeAfterTransition
      disableScrollLock
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{}}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "350px",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,

            textAlign: "center",
          }}
        >
          <Box sx={{ mb: 3 }}>
            {header && (
              <Typography variant="h4" gutterBottom>
                {header}
              </Typography>
            )}
            <Typography variant="body1" gutterBottom>
              {message}
            </Typography>
          </Box>
          <Box position="relative" display="inline-flex">
            <CircularProgress size={100} />
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
